import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map } from 'rxjs/operators';

import {
    update_site_selection,
    update_site_selection_failure,
    update_site_selection_success,
} from '../actions/configurable-sites.action';

@Injectable()
export class ConfigurableSitesEffects {
    updateSiteSelection$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(update_site_selection),
            map((data) => update_site_selection_success(data)),
            catchError(async () => update_site_selection_failure),
        );
    });

    constructor(private actions$: Actions) {}
}
